import { PropsWithChildren } from 'react';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Button, CircularProgress, DialogActions, DialogContent, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAppDispatch,useAppSelector } from 'app/hooks';
import { PopOver } from 'common/components/PopOver';

import { selectIsDialogOpen, setCurrentEntityType, setDialogOpen } from './deleteDialogSlice';

interface IDeleteDialogProps {
    deleteCallback: ()=> void;
    processing: boolean;
    title?: string;
    customDeleteTitle?: string;
    customWarningMessage?: string;
    deleteButtonDisabled?: boolean;
}

export const DeleteDialog = (props: PropsWithChildren<IDeleteDialogProps>) => {
    const { title, customDeleteTitle, deleteCallback, processing, children, customWarningMessage='This action cannot be undone.', deleteButtonDisabled=false } = props;
    const dialogIsOpen = useAppSelector(selectIsDialogOpen);
    const dispatch = useAppDispatch();
    const theme = useTheme();

    const onDeleteDialogClose = ()=> {
        dispatch(setDialogOpen(false));
        dispatch(setCurrentEntityType());
    };

    return (
        <PopOver
            title={customDeleteTitle ?? `Are you sure you want to delete this ${title}?`}
            open={dialogIsOpen}
            onClose={onDeleteDialogClose}
        >
            <Typography
                textAlign='center'
                color="info.light"
                sx={{ paddingTop: '0.7rem', maxWidth: '27rem' }}>
                {customWarningMessage}
            </Typography>
            <div style={{
                backgroundColor: theme.palette.error.main,
                height: '3rem',
                width: '3rem',
                borderRadius: '100%',
                position: 'absolute',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}>
                <DeleteOutlineOutlinedIcon fontSize='large'
                    sx={{
                        color: 'common.white',
                        marginTop: '7px',
                        marginLeft: '6px'
                    }}
                />
            </div>
            <DialogContent
                sx={{
                    textAlign: 'left',
                    marginTop: '1.5rem',
                    padding: '1.5rem 2rem'
                }}
                dividers>
                {children}
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ padding: '1rem 0' }}>
                    <Button variant="contained" color="error" disabled={processing || deleteButtonDisabled} onClick={deleteCallback}>
                        Delete
                        {processing &&
                            <CircularProgress  size='1rem' sx={{ marginLeft: '7px', color: theme.palette.error.light }}/>}
                    </Button>
                    <Button variant="outlined" onClick={onDeleteDialogClose} >
                        Cancel
                    </Button>
                </Stack>
            </DialogActions>
        </PopOver>
    );
};
